import { APIS } from '../constants/apis';
import { fetchAPI } from '../utils/fetchAPI';

export const saveVideo = async ({ jwt, data }) => {
  try {
    await fetchAPI({
      url: APIS.saveVideo,
      method: 'POST',
      header: {
        Authorization: `Bearer ${jwt}`,
      },
      data,
    });
  } catch (err) {
    throw new Error(err.message);
  }
};
